<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="680px"
    :close-on-click-modal="false"
    @close="handleClose"
    append-to-body
    custom-class="person-form-dialog"
  >
    <el-form
      ref="personForm"
      :model="form"
      :rules="formRules"
      label-width="140px"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名：" prop="realName">
            <el-input v-model="form.realName" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别：" prop="sex">
            <el-select
              v-model="form.sex"
              placeholder="请选择性别"
              style="width: 100%"
            >
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="与报名者关系：" prop="relationship">
            <el-select
              v-model="form.relationship"
              placeholder="请选择报名者关系"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in relationshipOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号码：" prop="idCardNo">
            <el-input
              v-model="form.idCardNo"
              placeholder="请输入身份证号"
              maxlength="18"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入手机号" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import sysDataconstantApi from "@/api/config/sysDataconstant";

export default {
  name: "PersonFormDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "新建报名人"
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    userId: {
      type: [Number, String],
      default: null
    },
    userInfoId: {
      type: [Number, String],
      default: null
    },
    userType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      relationshipOptions: [], // 关系选项列表
      form: {
        realName: "",
        sex: null,
        relationship: "",
        idCardNo: "",
        mobile: "",
        isChild: false
      },
      formRules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        relationship: [
          { required: true, message: "请选择报名者关系", trigger: "change" }
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
            trigger: "blur"
          }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.initForm();
        this.loadRelationshipOptions();
      }
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
    formData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.form = {
            realName: newVal.realName || "",
            sex: newVal.sex || null,
            relationship: newVal.relationship || "",
            idCardNo: newVal.idCardNo || "",
            mobile: newVal.mobile || "",
            isChild: newVal.isChild || false
          };
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 根据身份证号计算年龄
    calculateAgeFromIdCard(idCard) {
      if (!idCard) return null;

      let birthDate = null;

      // 18位身份证号：前6位地区码，中间8位出生日期（YYYYMMDD），后4位
      if (idCard.length === 18) {
        const year = parseInt(idCard.substring(6, 10));
        const month = parseInt(idCard.substring(10, 12));
        const day = parseInt(idCard.substring(12, 14));
        birthDate = new Date(year, month - 1, day);
      }
      // 15位身份证号：前6位地区码，中间6位出生日期（YYMMDD），后3位
      else if (idCard.length === 15) {
        const year = parseInt("19" + idCard.substring(6, 8)); // 15位身份证年份前加19
        const month = parseInt(idCard.substring(8, 10));
        const day = parseInt(idCard.substring(10, 12));
        birthDate = new Date(year, month - 1, day);
      }

      if (!birthDate || isNaN(birthDate.getTime())) {
        return null;
      }

      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      // 如果还没过生日，年龄减1
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return age;
    },
    // 加载关系选项列表
    async loadRelationshipOptions() {
      try {
        const { data } = await sysDataconstantApi.fetchBatchCode({
          code: "withMyRelationship"
        });
        // 处理返回数据，取第一条数据的 content 字段，用逗号分隔
        let dataList = [];
        if (
          data &&
          data.list &&
          Array.isArray(data.list) &&
          data.list.length > 0
        ) {
          dataList = data.list;
        } else if (data && Array.isArray(data) && data.length > 0) {
          dataList = data;
        }

        // 取第一条数据的 content 字段
        if (dataList.length > 0 && dataList[0].content) {
          const contentStr = dataList[0].content;
          // 用逗号分隔，生成选项列表，过滤掉"本人"（新增时不应该有"本人"选项，本人由后端返回）
          this.relationshipOptions = contentStr
            .split(",")
            .map(item => item.trim())
            .filter(item => item && item !== "本人") // 过滤空字符串和"本人"
            .map((item, index) => ({
              id: index,
              name: item
            }));
        } else {
          this.relationshipOptions = [];
        }
      } catch (error) {
        console.error("加载关系选项失败:", error);
        this.relationshipOptions = [];
      }
    },
    initForm() {
      if (this.formData && Object.keys(this.formData).length > 0) {
        this.form = {
          realName: this.formData.realName || "",
          sex: this.formData.sex || null,
          relationship: this.formData.relationship || "",
          idCardNo: this.formData.idCardNo || "",
          mobile: this.formData.mobile || "",
          isChild: this.formData.isChild || false
        };
      } else {
        this.resetForm();
      }
      this.$nextTick(() => {
        if (this.$refs.personForm) {
          this.$refs.personForm.clearValidate();
        }
      });
    },
    resetForm() {
      this.form = {
        realName: "",
        sex: null,
        relationship: "",
        idCardNo: "",
        mobile: "",
        isChild: false
      };
    },
    handleClose() {
      this.resetForm();
      this.$emit("close");
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      this.$refs.personForm.validate(valid => {
        if (valid) {
          // 不允许创建"本人"记录（后端已返回id为null的"本人"数据）
          if (this.form.relationship === "本人") {
            this.$message.warning("本人数据由后端提供，不允许新增");
            return;
          }

          // 如果是添加儿童，需要验证年龄
          if (this.form.isChild) {
            const age = this.calculateAgeFromIdCard(this.form.idCardNo);

            // 如果无法计算年龄（身份证格式可能有问题），仍然允许提交，由身份证验证规则处理
            if (age !== null && age > 14) {
              this.$message.warning("年龄大于14岁，请添加成人");
              return;
            }
          }

          const personData = {
            ...this.form,
            userId: this.userId || null,
            userInfoId: this.userInfoId || null,
            userType: this.userType || null
          };
          // 触发 confirm 事件，但不关闭弹窗，由父组件决定是否关闭
          this.$emit("confirm", personData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  background-color: #f8f8f8;
  .el-dialog__header {
    padding: 6px 40px;
    background-color: #e9f3f7;
    .el-dialog__title {
      color: #4680e3;
      font-size: 14px;
    }
    .el-dialog__headerbtn {
      top: 8px;
    }
  }
  .el-dialog__body {
    padding: 15px 30px;
    max-height: 80vh;
    overflow-y: auto;
  }
}
/* 新增/编辑报名人表单弹窗样式 */
::v-deep .person-form-dialog {
  .el-dialog__body,
  .el-dialog__footer {
    background-color: #fff;
  }
}
</style>
